import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { switchMap, takeUntil } from 'rxjs/operators';
import { UserPermissions } from '../../../constants/user-permissions';
import { AdviceNoteDto } from '../../../models/dto/advice-note-dto.model';
import { AdviceNotesService } from '../../../services/advice-notes.service';
import { BaseConfirmationDialogComponent } from '../base-confirmation-dialog.component';

@Component({
  selector: 'boi-advice-notes-dialog',
  templateUrl: './advice-notes-dialog.component.html',
  styleUrls: ['./advice-notes-dialog.component.scss']
})
export class AdviceNotesDialogComponent extends BaseConfirmationDialogComponent<any> implements OnInit {
  @Input() public opened: boolean;
  @Input() public caseId: string;
  @Output() public readonly openedChange = new EventEmitter<boolean>();
  public noteText = '';
  public adviceNotes: Array<AdviceNoteDto>;
  public userPermissions = UserPermissions;

  constructor(private readonly adviceNotesService: AdviceNotesService) {
    super();
  }

  public ngOnInit(): void {
    this.adviceNotesService
      .getAdviceNotes(this.caseId)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((notes) => (this.adviceNotes = notes));
  }

  public addAdviceNote(): void {
    this.adviceNotesService
      .addAdviceNote(this.caseId, this.noteText)
      .pipe(switchMap(() => this.adviceNotesService.getAdviceNotes(this.caseId)))
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((notes) => {
        this.adviceNotes = notes;
        this.noteText = '';
      });
  }
}
